/* cosmic-quick-add-upgrade.js - Veirdo Gallery Upgrade */

(function() {
  function attachObserver(modal) {
    new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        if (m.attributeName === 'open' && modal.hasAttribute('open')) {
          waitForImages(modal);
        }
      });
    }).observe(modal, { attributes: true });
  }

  document.querySelectorAll('quick-add-modal').forEach(attachObserver);

  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.tagName === 'QUICK-ADD-MODAL') attachObserver(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  function waitForImages(modal) {
    let tries = 0;
    const poll = setInterval(() => {
      const mediaEl = modal.querySelector('.cosmic-product-media');
      if (mediaEl && !mediaEl.querySelector('.cqa-thumb-strip')) {
        const imgs = mediaEl.querySelectorAll('.cosmic-media-item img');
        if (imgs.length > 0) {
          clearInterval(poll);
          buildGallery(mediaEl, Array.from(imgs));
          reinitTimer(modal);
          reinitSizeGuide(modal);
          return;
        }
      }
      if (++tries > 60) clearInterval(poll);
    }, 100);
  }

  function getBestSrc(img) {
    const srcset = img.srcset || img.dataset.srcset || '';
    if (srcset) {
      const entries = srcset.split(',').map(s => {
        const parts = s.trim().split(/\s+/);
        return { src: parts[0], w: parseInt(parts[1]) || 0 };
      });
      entries.sort((a, b) => b.w - a.w);
      if (entries[0] && entries[0].src) return entries[0].src;
    }
    let src = (img.src || '').trim();
    if (src.includes('cdn.shopify.com')) {
      src = src.replace(/(_\d+x\d*|_\d*x\d+)(\.\w+)(\?|$)/, '$2$3');
      src = src.replace(/width=\d+/, 'width=900');
    }
    return src;
  }

  function buildGallery(mediaEl, imgs) {
    const srcs = imgs.map(getBestSrc).filter(Boolean);
    if (srcs.length === 0) return;

    let currentIndex = 0;

    const thumbsHTML = srcs.map((src, i) => `
      <div class="cqa-thumb ${i === 0 ? 'is-active' : ''}" data-i="${i}">
        <img src="${src}" alt="View ${i + 1}" loading="lazy">
      </div>
    `).join('');

    mediaEl.innerHTML = `
      <div class="cqa-thumb-strip">${thumbsHTML}</div>
      <div class="cqa-main-wrap">
        <button class="cqa-arrow prev" aria-label="Previous image">&#8249;</button>
        <img class="cqa-main-img" src="${srcs[0]}" alt="Product">
        <button class="cqa-arrow next" aria-label="Next image">&#8250;</button>
      </div>
    `;

    const mainImg = mediaEl.querySelector('.cqa-main-img');
    const thumbs = mediaEl.querySelectorAll('.cqa-thumb');
    const prevBtn = mediaEl.querySelector('.cqa-arrow.prev');
    const nextBtn = mediaEl.querySelector('.cqa-arrow.next');

    const goTo = (index) => {
      currentIndex = (index + srcs.length) % srcs.length;
      mainImg.style.opacity = '0';
      setTimeout(() => {
        mainImg.src = srcs[currentIndex];
        mainImg.style.opacity = '1';
      }, 200);
      thumbs.forEach((t) => t.classList.toggle('is-active', parseInt(t.dataset.i) === currentIndex));
    };

    thumbs.forEach((t) => t.addEventListener('click', () => goTo(parseInt(t.dataset.i))));
    prevBtn.addEventListener('click', (e) => { e.stopPropagation(); goTo(currentIndex - 1); });
    nextBtn.addEventListener('click', (e) => { e.stopPropagation(); goTo(currentIndex + 1); });
  }

  /* -------------------------------------------------------
     Re-initialize Urgency Timer inside the popup
     The timer spans get new IDs after quick-add deduplication,
     so we query them by class instead.
  ------------------------------------------------------- */
  function reinitTimer(modal) {
    const timerEl = modal.querySelector('.cosmic-urgency-timer');
    if (!timerEl) return;

    // Find spans by id (timer-hours etc may survive if they don't contain section id)
    // Fall back to positional query
    const hoursEl = timerEl.querySelector('[id*="timer-hours"]') || timerEl.querySelectorAll('span')[0];
    const minsEl  = timerEl.querySelector('[id*="timer-mins"]')  || timerEl.querySelectorAll('span')[1];
    const secsEl  = timerEl.querySelector('[id*="timer-secs"]')  || timerEl.querySelectorAll('span')[2];

    if (!hoursEl || !minsEl || !secsEl) return;

    function tick() {
      const now = new Date();
      const midnight = new Date();
      midnight.setHours(24, 0, 0, 0);
      const diff = midnight - now;
      hoursEl.textContent = String(Math.floor(diff / 3600000)).padStart(2, '0');
      minsEl.textContent  = String(Math.floor((diff / 60000) % 60)).padStart(2, '0');
      secsEl.textContent  = String(Math.floor((diff / 1000) % 60)).padStart(2, '0');
    }

    tick();
    const interval = setInterval(tick, 1000);

    // Clean up when modal closes
    modal.addEventListener('hide', () => clearInterval(interval), { once: true });
  }

  /* -------------------------------------------------------
     Re-initialize Size Guide inside the popup
     The size guide trigger uses getElementById which only
     runs at DOMContentLoaded. We re-bind the button here.
  ------------------------------------------------------- */
  function reinitSizeGuide(modal) {
    const trigger = modal.querySelector('.cosmic-size-guide-link');
    if (!trigger) return;

    // The size guide modal HTML was injected inside the quick add container!
    const guideModal = modal.querySelector('.cosmic-modal-overlay') || document.getElementById('cosmic-size-guide-modal');
    if (!guideModal) return;

    const closeBtn = guideModal.querySelector('.cosmic-modal-close') || document.getElementById('size-guide-close');

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      guideModal.classList.add('active');
      guideModal.style.opacity = '';
      guideModal.style.visibility = '';
    });

    if (closeBtn && !closeBtn.dataset.cqaBound) {
      closeBtn.dataset.cqaBound = '1';
      closeBtn.addEventListener('click', () => guideModal.classList.remove('active'));
      guideModal.addEventListener('click', (e) => {
        if (e.target === guideModal) guideModal.classList.remove('active');
      });
    }
  }
})();
